<template>
  <el-tabs v-model="selectedTab">
    <!-- <el-tab-pane
      name="list"
      label="列表"
    >
      <instrument-list></instrument-list>
    </el-tab-pane> -->
    <el-tab-pane
      name="create"
      label="新增"
      :lazy="true"
    >
      <client-form form-type="create" />
    </el-tab-pane>
    <el-tab-pane
      name="edit"
      label="編輯"
      :lazy="true"
    >
      <client-form form-type="edit" />
    </el-tab-pane>
    <el-tab-pane label="用戶清單" name="relation" :lazy="true">
      <UserProjectRelation />
    </el-tab-pane>
    <el-tab-pane label="邊坡告警設定" name="alertGroup" :lazy="true">
      <AlertGroupManagement />
    </el-tab-pane>
    <el-tab-pane label="其他專案告警設定" name="projectAlert" :lazy="true">
      <UserProjectAlertSetting />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import ClientForm from '@/components/client/Form';
import UserProjectRelation from '@/components/client/UserProjectRelation.vue';
import AlertGroupManagement from '@/components/client/AlertGroupManagement.vue';
import UserProjectAlertSetting from '@/components/client/UserProjectAlertSetting.vue';
export default {
  components: {
    ClientForm,
    UserProjectRelation,
    AlertGroupManagement,
    UserProjectAlertSetting,
  },
  data() {
    return {
      selectedTab: 'create',
    };
  },
};
</script>
